/**
 * The BSON type aliases.
 */
const BSON_TYPE_ALIASES = [
  {
    name: 'double',
    value: 'double',
    label: 'double',
    score: 1,
    meta: 'bson-type-aliases',
    version: '3.6.0'
  },
  {
    name: 'string',
    value: 'string',
    label: 'string',
    score: 1,
    meta: 'bson-type-aliases',
    version: '3.6.0'
  },
  {
    name: 'object',
    value: 'object',
    label: 'object',
    score: 1,
    meta: 'bson-type-aliases',
    version: '3.6.0'
  },
  {
    name: 'array',
    value: 'array',
    label: 'array',
    score: 1,
    meta: 'bson-type-aliases',
    version: '3.6.0'
  },
  {
    name: 'binData',
    value: 'binData',
    label: 'binData',
    score: 1,
    meta: 'bson-type-aliases',
    version: '3.6.0'
  },
  {
    name: 'objectId',
    value: 'objectId',
    label: 'objectId',
    score: 1,
    meta: 'bson-type-aliases',
    version: '3.6.0'
  },
  {
    name: 'bool',
    value: 'bool',
    label: 'bool',
    score: 1,
    meta: 'bson-type-aliases',
    version: '3.6.0'
  },
  {
    name: 'date',
    value: 'date',
    label: 'date',
    score: 1,
    meta: 'bson-type-aliases',
    version: '3.6.0'
  },
  {
    name: 'null',
    value: 'null',
    label: 'null',
    score: 1,
    meta: 'bson-type-aliases',
    version: '3.6.0'
  },
  {
    name: 'double',
    value: 'double',
    label: 'double',
    score: 1,
    meta: 'bson-type-aliases',
    version: '3.6.0'
  },
  {
    name: 'regex',
    value: 'regex',
    label: 'regex',
    score: 1,
    meta: 'bson-type-aliases',
    version: '3.6.0'
  },
  {
    name: 'javascript',
    value: 'javascript',
    label: 'javascript',
    score: 1,
    meta: 'bson-type-aliases',
    version: '3.6.0'
  },
  {
    name: 'javascriptWithScope',
    value: 'javascriptWithScope',
    label: 'javascriptWithScope',
    score: 1,
    meta: 'bson-type-aliases',
    version: '3.6.0'
  },
  {
    name: 'int',
    value: 'int',
    label: 'int',
    score: 1,
    meta: 'bson-type-aliases',
    version: '3.6.0'
  },
  {
    name: 'timestamp',
    value: 'timestamp',
    label: 'timestamp',
    score: 1,
    meta: 'bson-type-aliases',
    version: '3.6.0'
  },
  {
    name: 'long',
    value: 'long',
    label: 'long',
    score: 1,
    meta: 'bson-type-aliases',
    version: '3.6.0'
  },
  {
    name: 'decimal',
    value: 'decimal',
    label: 'decimal',
    score: 1,
    meta: 'bson-type-aliases',
    version: '3.6.0'
  },
  {
    name: 'minKey',
    value: 'minKey',
    label: 'minKey',
    score: 1,
    meta: 'bson-type-aliases',
    version: '3.6.0'
  },
  {
    name: 'maxKey',
    value: 'maxKey',
    label: 'maxKey',
    score: 1,
    meta: 'bson-type-aliases',
    version: '3.6.0'
  }
];

module.exports = BSON_TYPE_ALIASES;
